export const leftMenu = {
  "Deseja voltar da pausa:": "Desea volver de la pausa:",
  "Tempo total em pausa:": "Tiempo total en pausa:",
  "Selecione o motivo da pausa": "Seleccione el motivo de la pausa",
  "Marcar Ponto": "Marcar Fichaje",
  "Marcar Pausa": "Iniciar Pausa",
  "Em Pausa": "En Pausa",
  "Voltar da pausa": "Volver de la pausa",
  "Cancelar": "Cancelar",
  "Confirmar pausa": "Confirmar pausa",
  "Marcar pausa": "Iniciar pausa",
  "Início": "Inicio",
  "Lembretes": "Recordatorios",
  "Gestão de tarefas": "Gestión de tareas",
  "Comunicados": "Comunicados",
  "Documentos": "Documentos",
  "Feedbacks": "Comentarios",
  "Reuniões 1:1": "Reuniones 1:1",
  "Reembolsos": "Reembolsos",
  "Saldo de horas": "Saldo de horas",
  "Solicitações de ajuste": "Solicitudes de ajuste",
  "Férias/Afastamento": "Vacaciones y ausencias",
  "Histórico de Ponto": "Historial de Fichajes",
  "Espelhos de Ponto": "Informes de Fichajes",
  "Log de Registros": "Registro de Actividad",
  "Modo ponto": "Modo Fichaje",
  "Minha equipe": "Mi Equipo",
  "Gestão de Ponto": "Gestión de Fichajes",
  "Gerenciar afastamentos": "Gestionar Ausencias",
  "Solicitações da equipe": "Solicitudes del Equipo",
  "Sobreaviso": "De guardia",
  "Modo escuro": "Modo oscuro",
  "Modo claro": "Modo claro",
  "Meu perfil": "Mi Perfil",
  "Ouvidoria": "Defensoría del Empleado",
  "Política de privacidade": "Política de privacidad",
  "Sair": "Cerrar sesión"
};


// WEBPACK FOOTER //
// ./src/resources/es/leftMenu.js